<template>
  <div class="integrations-container">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center font-semibold text-base">
        <img
          v-if="code === 'google-classroom'"
          class="w-8 h-8 rounded-full"
          :src="icon"
        />
        <img
          v-else
          class="w-8 h-8 rounded-full"
          :src="`/static/integrations/${title}.png`"
        />
        <span class="ml-3 h-full">{{ title }}</span>
      </div>
      <div class="ml-4">
        <template>
          <button
            v-if="!integration_connected"
            class="py-2 w-36 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50"
            @click="connectIntegration"
          >
            Connect
          </button>
          <button
            v-else
            class="py-2 w-36 bg-red-400 rounded cursor-pointer text-white font-semibold disabled:opacity-50"
            @click="disconnectIntegration"
          >
            Disconnect
          </button>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import googleClassroom from 'utils/googleClassroom';
  import urlConfigs from 'services/apiConfigs';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {};
    },
    props: {
      integration: {
        type: Object,
        default() {
          return {};
        },
      },
      title: {
        type: String,
        default: '',
      },
      code: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapGetters(['getCourseDetail', 'getProfile', 'getMySubscription']),
      integration_connected() {
        if (this.code === 'google-classroom') {
          if (this.getProfile.google_integration.connected) {
            return this.getProfile.google_integration.connected;
          }
          return null;
        } else if (
          this.getProfile.edlink_integrations &&
          this.getProfile.edlink_integrations.length
        ) {
          const integration = this.getProfile.edlink_integrations.find(
            (x) => x.id === this.integration.id
          );
          if (integration && integration.connected) {
            return true;
          }
        }
        return false;
      },
      integration_course_name() {
        if (this.code === 'google-classroom') {
          return this.getCourseDetail.google_classroom_integration.course_name;
        } else if (this.integration.connected) {
          if (
            this.getCourseDetail &&
            this.getCourseDetail.edlink_integrations
          ) {
            const integration = this.getCourseDetail.edlink_integrations.find(
              (integration) =>
                integration.provider_name.toLowerCase() ===
                this.integration.name.toLowerCase()
            );
            return integration ? integration.course_name : null;
          }
          return;
        }
        return;
      },
    },
    methods: {
      connectIntegration() {
        if (this.code === 'google-classroom') {
          this.connectGoogleClassroom();
        } else {
          this.connectEdlinkIntegration();
        }
      },
      disconnectIntegration() {
        if (this.code === 'google-classroom') {
          this.disconnectGoogleClassroom();
        } else {
          this.disconnectEdlinkIntegration();
        }
      },
      async connectGoogleClassroom() {
        if (!this.getProfile.google_integration.connected) {
          const { code, email } = await googleClassroom.getCode('student');
          const payload = {
            code,
            redirect_uri: urlConfigs.uiURL,
            email,
          };
          const course_id = this.getCourseDetail.id;
          this.$store.dispatch('connectStudentGoogleClassroomIntegration', {
            course_id,
            payload,
          });
        }
      },
      connectEdlinkIntegration() {
        const course_id = this.$route.params.courseID;
        const redirect_uri = `${urlConfigs.uiURL}/dashboard`;
        if (
          this.getMySubscription.edlink_integrations &&
          this.getMySubscription.edlink_integrations.length
        ) {
          for (
            let i = 0;
            i < this.getMySubscription.edlink_integrations.length;
            i += 1
          ) {
            const user_integration = this.getProfile.edlink_integrations.find(
              (x) => x.id === this.integration.id
            );
            const integration_id = this.integration.id;

            if (!user_integration) {
              this.$store
                .dispatch('getSsoCourseMetadata', {
                  course_id,
                  redirect_uri,
                  integration_id,
                })
                .then((res) => {
                  if (res.sso_login_url) {
                    window.open(res.sso_login_url, '_self');
                  }
                });
            }
          }
        }
      },
      disconnectGoogleClassroom() {
        const course_id = this.$route.params.courseID;
        this.$store
          .dispatch('disconnectStudentGoogleClassroomIntegration', {
            course_id,
          })
          .then(() => {
            EventBus.$emit(
              'toast-msg',
              'You have been disconnected from Google Classroom with success.'
            );
          })
          .catch((err) => {
            console.error(err);
          });
      },
      disconnectEdlinkIntegration() {
        const course_id = this.$route.params.courseID;
        const integration_id = this.integration.id;

        this.$store
          .dispatch('disconnectStudentSsoIntegration', {
            course_id,
            integration_id,
          })
          .then(() => {
            EventBus.$emit(
              'toast-msg',
              'You have been disconnected from LMS integration with success.'
            );
          })
          .catch((err) => {
            console.error(err);
          });
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .integrations-container
    margin: 30px 0 0 0
    padding: 1rem
    border-right: 1px solid rgba(0,0,0,.2)
    border-bottom: 1px solid rgba(0,0,0,.2)
  .classroom-title
    font-size: 18px
    line-height: 22px
    color: #273248
    font-weight: 600
  .integration-icon
    width: 40px
    height: 40px
  .classroom_connected
    margin: 16px 0 0 0
  .name-of-class
    font-size: 24px
    line-height: 29px
    color: #273248
    font-weight: 600
</style>



// WEBPACK FOOTER //
// integrationStudentCard.vue?4557b0c8